// extracted by mini-css-extract-plugin
module.exports = {"item-head":"item-head__2FYud","info-cont":"info-cont__2mtd-","wrap":"wrap__-HCTj","automateWrap":"automateWrap__SaUao"};